import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

type State = {
  kpiList: any[];
  isKpiDrawerOpen: boolean;
  kpiMetaConfigs: any;
};

const initialState: State = {
  kpiList: [],
  isKpiDrawerOpen: false,
  kpiMetaConfigs: {},
};

const kpiStore = create(
  devtools(
    (set: any) => ({
      ...initialState,
      setKPIs: (kpiList) => set(() => ({ kpiList })),
      setIsKpiDrawerOpen: (isKpiDrawerOpen) => set(() => ({ isKpiDrawerOpen })),
      setKpiMetaConfigs: (kpiMetaConfigs) => set(() => ({ kpiMetaConfigs })),
    }),
    { name: 'kpiStore' },
  ),
);

export default kpiStore;
